<template>
  <v-container text-xs-center>
    <div id="app">
      <v-app id="inspire" class="white--text">
        <v-data-table
          disable-pagination
          :headers="headers"
          :items="recordsList"
          :search="search"
          dense
          background-color="primary"
        >
          <!-- <template v-slot:headerCell="props">
       <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
    </template> -->
          <template v-slot:item.distance="{ item }">
            <v-chip class="ma-2" color="primary" label small>
              <v-icon left>mdi-account-circle-outline</v-icon>
              {{ item.distance + " " + item.stroke }}</v-chip
            >
          </template>

          <template v-slot:item.mResultDate="{ item }">
            <v-chip v-if="compareDate(item.mResultDate)" color="red"
              >{{ item.mResultDate }}
              <v-icon> new_releases </v-icon>
            </v-chip>
            <v-chip v-else>{{ item.mResultDate }} </v-chip>
          </template>
          <template v-slot:item.fResultDate="{ item }">
            <v-chip v-if="compareDate(item.fResultDate)" color="red"
              >{{ item.fResultDate }}
              <v-icon> new_releases </v-icon>
            </v-chip>
            <v-chip v-else>{{ item.fResultDate }} </v-chip>
          </template>

          <template v-slot:top>
            <BaseToolbar
              :toolbarTitle="
                'Records ' +
                facilityType +
                ' Age Range ' +
                ageFrom +
                '-' +
                ageTo
              "
            >
              <template v-slot:toolbarSearch>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </template>
            </BaseToolbar>
            <SecondToolbar
              :changeHeight="false"
              v-if="!$store.getters.hasZenMode"
            >
              <template v-slot:toolbarContent>
                <v-autocomplete
                  v-model="facilityType"
                  required
                  hide-details
                  dense
                  outlined
                  class="mr-sm-2 my-3 my-sm-0"
                  :hint="`${facilityType}`"
                  label="Select Facility Type"
                  @input="handleGetRecords()"
                  :items="['25m', '50m', '25y']"
                  item-value="facilityType"
                  item-text="facilityType"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="daysOld"
                  required
                  hide-details
                  outlined
                  class="mr-sm-2 mb-3 mb-sm-0"
                  dense
                  :hint="`${daysOld}`"
                  label="Days Old"
                  @input="handleGetRecords()"
                  :items="Array.from(Array(1000).keys())"
                  item-value="daysOld"
                  item-text="daysOld"
                >
                </v-autocomplete>
                <v-autocomplete
                  v-model="ageFrom"
                  required
                  outlined
                  dense
                  class="mr-sm-2 mb-3 mb-sm-0"
                  hide-details
                  :hint="`${ageFrom}`"
                  label="Age From"
                  @input="handleGetRecords()"
                  :items="Array.from(Array(100).keys())"
                  item-value="ageFrom"
                  item-text="ageFrom"
                >
                </v-autocomplete>
                <v-autocomplete
                  v-model="ageTo"
                  required
                  :hint="`${ageTo}`"
                  label="Age To"
                  outlined
                  class="mb-3 mb-sm-0"
                  hide-details
                  dense
                  @input="handleGetRecords()"
                  :items="Array.from(Array(100).keys())"
                  item-value="ageTo"
                  item-text="ageTo"
                >
                </v-autocomplete>
              </template>
            </SecondToolbar>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import BaseToolbar from "@/components/base/BaseToolbar";
import SecondToolbar from "@/components/base/BaseToolbarV2";

export default {
  name: "home",
  components: { BaseToolbar, SecondToolbar },
  data() {
    return {
      search: "",
      daysOld: 31,
      rowsPerPageItems: [15, 30, 45],
      facilityType: "25m",
      ageFrom: 1,
      ageTo: 20,
      isMobile: false,
      pagination: {
        rowsPerPage: 15,
      },
    };
  },
  created() {
    //Distructure URL i.e. this.$route.query
    //distructure from: http://localhost:8080/16/club/Ranks?gender&bestOnly=Y&daysOld=31&facilityType=50m&newOnly=Y

    const query = this.$route.query;

    // Use defaults from current data
    this.ageFrom = this.parseOrDefault(query.ageFrom, this.ageFrom);
    this.ageTo = this.parseOrDefault(query.ageTo, this.ageTo);
    this.daysOld = this.parseOrDefault(query.daysOld, this.daysOld);
    this.facilityType = query.facilityType || this.facilityType;
    this.handleGetRecords();
  },
  mounted() {
    //
  },
  computed: {
    ...mapGetters(["loading", "recordsList"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    dialog() {
      return false;
    },
    headers() {
      let headers = [
        {
          text: "NAME",
          align: "left",
          sortable: true,
          value: "mFirstName",
          class: ["column-color_new"],
        },
        { text: "DATE", value: "mResultDate" },
        {
          text: "RESULT\n(BOYS)",
          value: "mResultTime",
          class: ["column-color"],
        },
        {
          text: "Club",
          value: "mClubName",
          align: this.$route.params.league ? "" : " d-none",
        },
        { text: "Event", value: "distance" },
        {
          text: "Club",
          value: "fClubName",
          align: this.$route.params.league ? "" : " d-none",
        },
        {
          text: "RESULT\n(GIRLS)",
          value: "fResultTime",
          class: ["column-color"],
        },
        { text: "DATE", value: "fResultDate", class: ["column-color"] },
        {
          text: "NAME",
          align: "left",
          sortable: true,
          value: "fFirstName",
          class: ["column-color"],
        },
      ];

      return headers;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    "$route.params.league": function () {
      this.handleGetRecords();
    },
    "$route.params.club": function () {
      this.handleGetRecords();
    },
  },

  methods: {
    parseOrDefault(value, defaultValue) {
      const parsed = parseInt(value);
      return !isNaN(parsed) ? parsed : defaultValue;
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    handleGetRecords() {
      // add query parameters to url
      this.$router.replace({
        query: {
          ageFrom: this.ageFrom,
          ageTo: this.ageTo,
          daysOld: this.daysOld,
          facilityType: this.facilityType,
        },
      });

      //reach out of Vuex store, fire action that gets posts for carousel
      this.$store.dispatch("allRecordsList", {
        leagueSeqno: this.$route.params.league,
        clubId: this.$route.params.club,
        ageFrom: this.ageFrom,
        ageTo: this.ageTo,
        facilityType: this.facilityType,
      });
    },
    compareDate: function (item) {
      return Math.abs((new Date() - new Date(item)) / 86400000) < this.daysOld;
      //return 1;
    },
  },
};
</script>

<style></style>
